import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4l6 0","key":"svg-0"}],["path",{"d":"M14 4l6 0","key":"svg-1"}],["path",{"d":"M4 10a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2l0 -8","key":"svg-2"}],["path",{"d":"M14 10a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2l0 -2","key":"svg-3"}]]

const IconLayoutKanban = createReactComponent('outline', 'layout-kanban', 'LayoutKanban', __iconNode);

export default IconLayoutKanban;